export const testimonalData = [
    {
        "content":"Good quality eatables at affordable price and hygiene place.. Very much underrated. !!",
        "contentTe":"సరసమైన ధరలో మంచి నాణ్యమైన తినుబండారాలు మరియు పరిశుభ్రమైన ప్రదేశం.. చాలా తక్కువగా గుర్తించబడింది. !!",
        "author":"Nithin Kumar"
    },
    {
        "content":"I gave five star rating because every thing was very Tasty because of pure ghee...",
        "contentTe":"స్వచ్ఛమైన నెయ్యి వల్ల ప్రతిదీ చాలా రుచికరంగా ఉన్నందున నేను ఐదు నక్షత్రాల రేటింగ్ ఇచ్చాను...",
        "author":"Mahima George"
    },
    {
        "content":"Popular sweets are available here.  Good service and packaging is good",
        "contentTe":"ఇక్కడ ప్రసిద్ధ స్వీట్లు లభిస్తాయి. మంచి సేవ మరియు ప్యాకేజింగ్ బాగుంది",
        "author":"Sravani Bangaram"
    }
]
